import React, { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import ApplicationContext from "../../context/ApplicationContext";
import { IPrinter } from "../../types/IPrinter";
import { IReceiptData } from "../../types/IReceiptData";
import { generateGUID } from "../../helpers/Helper";
import { IReceipt } from "../../types/IReceipt";

export interface IPrinterOptionsProps {
  close(): void;
  show: boolean;
}

export const PrinterOptionsModal: React.FC<IPrinterOptionsProps> = (
  props: IPrinterOptionsProps
): JSX.Element => {
  const context = useContext(ApplicationContext);

  function closeModal() {
    props.close();
  }

  function onPrinterClick(printer: IPrinter) {
    const printerOptions = printer.name.split(":");

    let printers: IPrinter[] = [];

    const availablePrinters = context.Configuration.getSettings().printers;

    printerOptions.forEach((additionalPrinter) => {
      availablePrinters.forEach((p) => {
        const pValues = p.name.split(":");
        if (pValues[0] === additionalPrinter) {
          printers.push(p);
        }
      });
    });

    doPrint(printers);
    props.close();
  }

  function onAllPrinterClick() {
    const printers = context.Configuration.getSettings().printers;
    doPrint(printers);
    props.close();
  }

  function onNonePrinterClick() {
    props.close();
  }

  function printerName(printer: IPrinter) {
    const values = printer.name.split(":");
    return values[0];
  }

  const messageModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => closeModal()} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Print ??</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ float: "left" }}>
              {context.Configuration.getSettings()
                .printers.sort((a, b) => (a.position > b.position ? 1 : -1))
                .map((p) => (
                  <div style={{ padding: 10, float: "left" }}>
                    <Button
                      variant="primary"
                      style={{
                        width: 150,
                        height: 100,
                        fontWeight: "bolder",
                        borderRadius: "10px",
                        fontSize: 16,
                      }}
                      onClick={() => onPrinterClick(p)}
                      key={p.id}
                    >
                      {printerName(p)}
                    </Button>
                  </div>
                ))}
            </div>

            {context.Configuration.getSettings().printers.length > 1 ? (
              <div style={{ padding: 10, float: "left" }}>
                <Button
                  variant="primary"
                  style={{
                    width: 100,
                    height: 100,
                    fontSize: "16px",
                    fontWeight: "bolder",
                  }}
                  onClick={() => onAllPrinterClick()}
                >
                  All
                </Button>
              </div>
            ) : (
              <></>
            )}

            <div style={{ padding: 10, float: "left" }}>
              <Button
                variant="primary"
                style={{
                  width: 100,
                  height: 100,
                  fontSize: "16px",
                  fontWeight: "bolder",
                }}
                onClick={() => onNonePrinterClick()}
              >
                No print
              </Button>
            </div>
          </Modal.Body>
          <Modal.Footer className="modal-footer">
            <div className="mr-auto"></div>
            <div>
              <Button
                className="btn bt-primary btn-lg"
                onClick={() => props.close()}
              >
                Close
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  function getTotal() {
    let total = 0;
    context.Receipt.getRows().forEach((r) => {
      total += r.qty * r.price;
    });
    return total;
  }

  async function doPrint(printers: IPrinter[]) {
    const rows = context.Receipt.getRows();
    const settings = context.Configuration.getSettings();

    const organisation = settings.organisation;

    const customer = context.Customer.getCustomer();
    const user = context.AuthenticatedUser.getUser().fullname;
    const transactionType = context.Receipt.getTransactionType();
    const paymentType = context.Receipt.getPaymentType();
    const receiptNumber = context.Receipt.getReceiptNumber();

    const table = context.Receipt.getTable();

    if (table !== undefined) {
      customer.name = table.description1;
    }

    let receipt: IReceipt = {
      id: 0,
      createdAt: new Date(),
      rows: rows,
      total: getTotal(),
      customerReceiptNumber: receiptNumber,
      organisation: organisation,
      customer: customer,
      transactionType: transactionType,
      paymentType: paymentType,
      user: user,
      endComment: organisation.endComment,
      enteredValue: "",
      changeGiven: "",
      printerSettings: printers,
      table: table !== undefined ? table.uuid : "",
    };

    const receiptData: IReceiptData = {
      receipt: receipt,
      token: context.AuthenticatedUser.getToken(),
      tableUuid: table !== undefined ? table.uuid : "",
    };

    const receiptJson = JSON.stringify(receiptData);
    var encodedStringBtoA = btoa(receiptJson);

    let url = "https://print.waepos.com/Default.aspx?id=" + 0;
    url += "&data=" + encodedStringBtoA;

    window.location.href = url;
  }

  return <>{messageModal()}</>;
};
